import { Box, ToggleButton, ToggleButtonGroup, Tooltip } from '@mui/material';
import { usePartyManager } from './PartyManagerContext';

const PartyTypeSelector = ({ disabled }) => {
  const { partyData, setPartyData } = usePartyManager();

  const handleChange = (event, newType) => {
    if (newType !== null) {
      setPartyData((prevData) => {
        const updatedData = { ...prevData, partyType: newType };
        if (newType === 'ORGANIZATION') {
          updatedData.salutation.edit = 'COMPANY';
        } else {
          updatedData.salutation.edit = 'NO_SALUTATION';
        }
        updatedData.salutation.selected = 'edit';
        return updatedData;
      });
    }
  };

  const toggleGroupComponent = (
    <ToggleButtonGroup
      value={partyData.partyType}
      exclusive
      onChange={handleChange}
      aria-label="Party-Typ"
      size="small"
      fullWidth
      disabled={disabled}
    >
      <ToggleButton
        value="ORGANIZATION"
        aria-label="Organisation"
        variant={
          partyData.partyType === 'ORGANIZATION' ? 'contained' : 'outlined'
        }
        color={partyData.partyType === 'ORGANIZATION' ? 'primary' : 'default'}
      >
        Firma
      </ToggleButton>
      <ToggleButton
        value="PERSON"
        aria-label="Person"
        variant={partyData.partyType === 'PERSON' ? 'contained' : 'outlined'}
        color={partyData.partyType === 'PERSON' ? 'primary' : 'default'}
      >
        Person
      </ToggleButton>
    </ToggleButtonGroup>
  );
  ('Der Party-Typ kann bei einer bestehenden Party nicht geändert werden.');
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', my: 1.5 }}>
      {disabled ? (
        <Tooltip
          title={
            partyData.partyType === 'PERSON'
              ? 'Der Wechslen von einem bestehenden Kontakt zu einer Firma ist nicht möglich.'
              : 'Der Wechsel von einer bestehenden Firma zu einem Kontakt ist nicht möglich.'
          }
        >
          <span style={{ display: 'block', width: '100%' }}>
            {toggleGroupComponent}
          </span>
        </Tooltip>
      ) : (
        toggleGroupComponent
      )}
    </Box>
  );
};

export default PartyTypeSelector;
